export default __webpack_public_path__ + "static/MD_SearchThumb_Cloud_Create-5d4ad556a9edee7ea1468ea906f89d22.webp";